import { render, staticRenderFns } from "./MobileTD9.vue?vue&type=template&id=d0d83ece&scoped=true"
import script from "./MobileTD9.vue?vue&type=script&lang=js"
export * from "./MobileTD9.vue?vue&type=script&lang=js"
import style0 from "./MobileTD9.vue?vue&type=style&index=0&id=d0d83ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d83ece",
  null
  
)

export default component.exports